import { ResourceOptions } from 'react-admin';
import { Resources } from '../../resource';

export { default as list } from './List';
import '../dataProvider';
export const name = Resources.redpacketRewardPoolBalances;
